import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const EventsPage = () => (
  <Container sx={{ py: 10, minHeight: 400 }}>
    <Typography variant="h3" align="center" gutterBottom>
      Events
    </Typography>
    <Typography align="center" sx={{ mb: 4 }}>
      Check back soon for upcoming events!
    </Typography>
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      {/* Placeholder for future event listings */}
    </Box>
  </Container>
);

export default EventsPage; 